import styled, { css } from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  z-index: 9;
  background: #ffffff;
  overflow: hidden;
  .creat-new-comments{
    display: flex;
    width: 100%;
    justify-content: left;
    align-items: center;
    padding-left: 0.5rem;
  }
`;
export const Header = styled.div`
  display: flex;
  margin-top: 0.5rem;
  width: 100%;
  min-height: 50px;
  padding: 0 0.5rem;
  justify-content: center;
  align-items: center;
  .card--number{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    user-select: none;
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0,0,0,.08);

  }
`;
export const NumberComments = styled.div`
  font-size: 14px;
  font-weight: bolder;
  max-height: 25px;
  min-width: 25px;
  text-align: center;
  color: #ffffff;
  border-radius: 20px;
  padding: 4px;

  ${({ color }) =>
    color &&
    css`
        &{     
          background-color: ${({ color }) => color};
          .category{
            color: ${({ color }) => color};
          }
        }
    `}
`;
export const AddComments = styled.button`
  border: none;
  outline: none;
  display: flex;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  color: #87909e;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover{
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
    background-color:#efefefef
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  max-height: calc(100% - 120px);
  flex-direction: column;
  padding: 0.5rem;
  gap: 0.75rem;
  overflow-y: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`;
export const ViewComments = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  .viewComments--card{
    cursor: pointer;
  }
`;
export const Card = styled.div`
  position: relative;
  width: 100%;
  max-height: 100px;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
  p{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .category{
    position: absolute;
    display: flex;
    top: -5px;
    width: 100%;
    max-height: 11px;
    align-items: center;
    .--name{
      background: red;
      border-radius: 4px;
      padding: 0 5px;
    }
  }
  .description{
    width: 100%;
    max-height: 55px;
    margin-top: 5px;
    overflow: hidden;
    font-size: 13px;
    font-weight: 400;
    color: #000;
    p{  
      line-height: 1.2;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      white-space: pre-wrap;
    }
  }
  .info--comments{
    display: flex;
    width: 100%;
    margin-top: 4px;
    height: 15px;
    color: #999;
    align-items: end;
    justify-content: end;
    font-size: 11px;
  }
  ${({ color }) =>
    color &&
    css`
      &{     
        border-left: 8px solid ${({ color }) => color};
        .category{
          .--name{
            font-weight: bolder;
            background-color:${({ color }) => color};
            color:#ffffff;
            border-radius: 4px;
            padding: 0 5px;
          }
          
        }
      }
  `}
`;
export const DetailsComment = styled.div`
  display: flex;
  width: 750px;
  height: 450px;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  .line-info{
    display: flex;
    width: 100%;
    height: 60px;
    align-items: center;
    gap: 1rem;
    padding: 0 1rem;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
    .info{
      display: flex;
      width: 90%;
      flex-direction: column;
    }
    .author{
      max-width: 80%;
      font-weight: 900;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .date{
      margin-top: 5px;
      color: #999;
      font-size: 11px;
    }
  }
  .line-card{
    width: 100%;
    height: 80%;
    margin-top: 1rem;
    .card{
      height: 100%;
      max-height: 100%;
    }
    .category{
      font-size: 14px;
    }
    .description{
      margin-top: 15px;
      max-height:calc(100% - 15px);
      p{
        white-space: pre-line;
        -webkit-line-clamp: 20;
      }
    }
  }
`;
export const NewComment = styled.div`
  display: flex;
  width: 750px;
  height: 450px;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  .line-card{
    width: 100%;
    height: 80%;
    margin-top: 1rem;
    .card{
      height: 100%;
      max-height: 100%;
    }
    .category{
      font-size: 14px;
    }
    .description{
      margin-top: 25px;
      max-height:calc(100% - 25px);
      textarea{
        border: none;
        resize: none;
        width: 100%;
        height: 100%;
        font-family: Montserrat,Sans-serif;
        font-size: 13px;
        font-weight: 400;
        color: #000;
        &:focus{
          outline:none;
        }
      } 
    }
  }
  .--save{
    display: flex;
    width: 100%;
    height: 60px;
    align-items: center;
    justify-content: right;
    padding: 0 1rem;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    background-color: #ffffff;
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0, 0, 0, .08);
  }
  ${({ inLoading }) =>
    inLoading &&
    css`
      &{     
        pointer-events: none;
        user-select: none;
        opacity: 0.4;
      }
  `}
`;
export const Separator = styled.div`
  display: flex;
  flex-direction: column;
  min-height:${({ isOpen }) => !isOpen && '40px'};
  .identification{
    display: flex;
    width: 100%;
    height: 35px;
    min-height: 35px;
    padding: 0.2rem;
    color:#ffffff;
    justify-content: center;
    align-items: center;
    border-radius: 6px 6px 0 0;
    font-weight:bolder;
    font-size: 14px;
    user-select: none;
    cursor: pointer;
    justify-content: space-between;
    .name--category{
      width: calc(100% - 4px);
      text-align: center;
    }
    .icon--action{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
    } 
  }
  .content{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    border-radius: 0 0 6px 6px;
    padding: 0.5rem;
    gap: 0.5rem;
  }  
  ${({ color }) =>
    color &&
    css`
      &{     
        .identification{
          background-color: ${({ color }) => color};
        }
        .content{
          border: 1px solid ${({ color }) => color};
        }
      }
  `}
  ${({ isOpen }) =>
    !isOpen &&
    css`
      &{   
        .identification{
          border-radius: 6px;
        }
        .content{
          height: 0px;
          overflow: hidden;
          padding: 0px;
          gap: 0px;
          border:none; 
        }
      }
    `
  }
`;
export const SelectCategory = styled.div`
  position: relative;
  width: 220px;
  height: 35px;
  border-radius: 4px;
  .preview{
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    background-color:#f6f6f6; 
    box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0,0,0,.08);
    border: 1px solid #e5e5e5;
    .ident{
      display: flex;
      height: 100%;
      width: 90%;
      padding: 0 5px;
      font-weight: bolder;
      justify-content: left;
      align-items: center;
    }
    .icon--action{
      display: flex;
      height: 100%;
      width: 10%;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem; 
    }
  }
  ${({ color }) =>
    color &&
    css`
      &{     
        .preview{
          background-color:${({ color }) => color};
          .ident{
            color:#ffffff;
          }
        }
      }
    `}
`;
export const Options = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  max-height: 120px;
  flex-direction: column;
  padding: 0.5rem;
  gap: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  box-shadow: 0 calc(2 / 16 * 1rem) calc(8 / 16 * 1rem) rgba(0,0,0,.08);
  overflow: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }

  ${({ isOpen }) =>
    !isOpen &&
    css`
      &{     
        padding: 0;
        height: 0px;
        border:none;
        overflow: hidden;
      }
    `}

  .options{
    li{
      display: flex;
      height: 30px;
      min-height: 30px;
      border-radius: 4px;
      justify-content: center;
      align-items: center;
      background: red;
    }
  }
`;
export const Option = styled.div`
  display: flex;
  height: 30px;
  padding: 0 5px;
  min-height: 30px;
  border-radius: 4px;
  justify-content: left;
  align-items: center;
  font-weight: bolder;
  cursor: pointer;

  &:hover{
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
  }

  ${({ color }) =>
    color &&
    css`
      &{     
        background-color:${({ color }) => color};
        span{
          color:#ffffff;
        }
      }
    `}
`;
export const BtnSave = styled.button`
  height: 30px;
  width: 110px;
  outline: none;
  border:none; 
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  font-weight: bolder;
  background: #1b72d6;
  color: #ffffff;
  cursor: pointer;
  &:hover{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const Actions = styled.div`
    display: flex;
    width: 100%;
    justify-content: end;
    div:nth-child(1){
        display: flex;
        gap: .5rem;
    };
    span {
        display: flex;
        height: 35px;
        width: 150px;
        justify-content: center;
        align-items: center;
        background: transparent;
        font-weight:500;
        color:#1891fb;
        cursor: pointer;
        border-radius: 4px;
        border: solid 1px;
        &:hover{
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
    };
    .dsUs {
        color: rgb(251,75,75) ;
    };
`;

export const MessageAlert = styled.div`
    max-width: 400px;
    > p {
        text-align: center;
        color: #ce3747;
    };
    span {
        color:#1D86FF;
    };
`;